import { render, staticRenderFns } from "./ContentType.vue?vue&type=template&id=1aa4617e&"
import script from "./ContentType.vue?vue&type=script&lang=js&"
export * from "./ContentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports